// VehicleTrackingContentFormWrapper.js
import React from 'react';
import { useMediaQuery } from '@mui/system';
import VehicleTrackingContentFormDesktop from 'src/components/VehicleTrackingDetails/VehicleTrackingContentForm/VehicleTrackingContentFormDesktop';
import useVehicleContentFormLogic from 'src/components/VehicleTrackingDetails/VehicleTrackingContentForm/useVehicleContentFormLogic';
import VehicleTrackingContentFormMobile from 'src/components/VehicleTrackingDetails/VehicleTrackingContentForm/VehicleTrackingContentFormMobile';

export default function VehicleTrackingContentFormWrapper({
  toggleAddVehicleContentDrawer,
}) {
  const isMobile = useMediaQuery('(max-width: 600px)');
  const logic = useVehicleContentFormLogic(toggleAddVehicleContentDrawer);

  return isMobile ? (
    <VehicleTrackingContentFormMobile
      toggleAddVehicleContentDrawer={toggleAddVehicleContentDrawer}
      logic={logic}
    />
  ) : (
    <VehicleTrackingContentFormDesktop
      toggleAddVehicleContentDrawer={toggleAddVehicleContentDrawer}
      logic={logic}
    />
  );
}
